import Channel from '../../classes/channel';
import EpgEvent from '../../classes/epgEvent';
import FastEvent from '../../classes/fastEvent';

enum PilotType {
  CHANNEL = 'channel',
  VOD = 'vod',
}

interface PilotProps {
  channel?: Channel;
  event?: EpgEvent;
  vod?: FastEvent;
}

interface PilotFooterProps {
  currentChannel?: Channel;
  currentEvent?: EpgEvent | FastEvent | null;
  type?: PilotType;
}

interface PilotProgressBarProps {
  display: boolean;
  event?: EpgEvent | FastEvent | null;
  type?: PilotType;
}

interface PilotProgressBarChannelProps {
  event?: EpgEvent | null;
}

export { PilotType };
export type {
  PilotProps,
  PilotFooterProps,
  PilotProgressBarProps,
  PilotProgressBarChannelProps,
};
